import type { SupportedLanguage } from '@/i18n';

export type Announcement = {
  /**
   * Stable, release-specific identifier. Changing it deliberately causes an
   * announcement to be shown again after a previous version was dismissed.
   */
  id: string;
  /** ISO 8601 UTC date, for example `2026-08-31T23:59:59Z`. */
  expiresAt: string;
  /** Every dashboard language must have its message defined here. */
  messages: Record<SupportedLanguage, string>;
};

/**
 * Add short-lived, dashboard-wide announcements here. The component renders
 * only entries whose `expiresAt` is in the future.
 *
 * Keep the id stable while changing a message. Use a new id only when the
 * announcement should be displayed again to people who dismissed the prior one.
 */
export const announcements: Announcement[] = [
  // {
  // id: 'governanceMove',
  // expiresAt: '2026-09-25T23:59:59Z',
  // messages: {
  //   da: 'Sektionen Content & Web Analysis er flyttet. Du finder den nu under Governance.',
  //   de: 'Der Bereich Content & Web Analysis wurde verschoben. Du findest ihn jetzt unter Governance.',
  //   en: 'Content & Web Analysis has moved. You can now find it under Governance.',
  //   es: 'La sección Content & Web Analysis se ha trasladado. Ahora la encontrarás en Governance.',
  //   fi: 'Content & Web Analysis -osio on siirretty. Löydät sen nyt kohdasta Governance.',
  //   fr: 'La section Content & Web Analysis a été déplacée. Vous la trouverez désormais dans Governance.',
  //   it: 'La sezione Content & Web Analysis è stata spostata. Ora la trovi in Governance.',
  //   nl: 'De sectie Content & Web Analysis is verplaatst. Je vindt deze nu onder Governance.',
  //   no: 'Seksjonen Content & Web Analysis er flyttet. Du finner den nå under Governance.',
  //   pl: 'Sekcja Content & Web Analysis została przeniesiona. Znajdziesz ją teraz w Governance.',
  //   pt: 'A secção Content & Web Analysis foi movida. Agora pode encontrá-la em Governance.',
  //   sv: 'Avsnittet Content & Web Analysis har flyttats. Du hittar det nu under Governance.',
  //   tr: 'Content & Web Analysis bölümü taşındı. Artık Governance altında bulabilirsiniz.',
  // },
  // },
];

export function isAnnouncementActive(
  announcement: Announcement,
  now = Date.now(),
): boolean {
  const expiresAt = Date.parse(announcement.expiresAt);
  return Number.isFinite(expiresAt) && expiresAt > now;
}

export function getActiveAnnouncements(now = Date.now()): Announcement[] {
  return announcements.filter((announcement) =>
    isAnnouncementActive(announcement, now),
  );
}
